import type {ImageAssetMeta} from '@yandex-delivery/assets'
import React, {forwardRef, memo} from 'react'

type ImageProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, keyof ImageAssetMeta> & Partial<ImageAssetMeta>

export const Image = memo(
  forwardRef<HTMLImageElement, ImageProps>(({srcSet, decoding = 'async', loading = 'lazy', ...props}, ref) => (
    <img {...{...props, ref, decoding, loading, src: srcSet?.[0] || props.src, srcSet: srcSet?.toString()}} />
  )),
)
